export default [
  {
    path: '/reports',
    name: 'Reports',
    component: () =>
      import(/* webpackChunkName: 'reports' */ './views/Index.vue')
  }
]
